/** Formata números no padrão pt-BR (milhares com ponto, decimais com vírgula). */
export const formatNumberWithThousandsSeparator = (value: number | null | undefined): string => {
  if (value == null || !Number.isFinite(value)) return '0';
  return new Intl.NumberFormat('pt-BR').format(value);
};

export const formatPrice = (value: number | null | undefined) => {
  if (value == null || !Number.isFinite(value)) return 'R$ 0,00';
  return `R$ ${value?.toFixed(2)?.toString()?.replace('.', ',')}`;
};

export const formatPercent = (value: number | null | undefined) => {
  if (value == null || !Number.isFinite(value)) return '0%';
  const absolute = Math.abs(value);
  return `${absolute.toFixed(1).toString().replace('.', ',')}%`;
};

export const setDiffPercentageText = (percentage: number) => {
  if (percentage > 100) {
    return 'mais caro';
  }
  return 'mais barato';
};
